<template>
  <div role="alertdialog" :aria-label="errorMessage" class="error-container">
    <div role="dialog" class="error-card">
      <button type="button" class="close-button" @click="onCloseClick">
        ✕
      </button>
      <div class="title-section">
        <img alt="warning sign icon" src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSIzMnB4IiB2ZXJzaW9uPSIxLjEiIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMycHgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6c2tldGNoPSJodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2gvbnMiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj48dGl0bGUvPjxkZWZzLz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGlkPSJJY29ucyBuZXcgQXJyYW5nZWQgTmFtZXMgQ29sb3IiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIj48ZyBmaWxsPSIjRkYwMDAwIiBpZD0iMTAxIFdhcm5pbmciPjxwYXRoIGQ9Ik0xNC40MjQyMzI3LDYuMTQ4MzkyNzUgQzE1LjI5NDI5ODcsNC43NDA3Mjk3NiAxNi43MDcwMjgsNC43NDQwODQ0MiAxNy41NzUwMjA1LDYuMTQ4MzkyNzUgTDI4LjM2MDEwOTksMjMuNTk3MzggQzI5LjUyMTYzODgsMjUuNDc2NTk1MSAyOC42NzU1NDYyLDI3IDI2LjQ3MTQwNjgsMjcgTDUuNTI3ODQ2NCwyNyBDMy4zMjMyMTU1NywyNyAyLjQ3Mzg2MzE3LDI1LjQ4MjY2NDIgMy42MzkxNDMzMSwyMy41OTczOCBaIE0xNiwyMCBDMTYuNTUyMjg0NywyMCAxNywxOS41NDY5NjM3IDE3LDE5LjAwMjk2OTkgTDE3LDEyLjk5NzAzMDEgQzE3LDEyLjQ0NjM4NTYgMTYuNTU2MTM1MiwxMiAxNiwxMiBDMTUuNDQ3NzE1MywxMiAxNSwxMi40NTMwMzYzIDE1LDEyLjk5NzAzMDEgTDE1LDE5LjAwMjk2OTkgQzE1LDE5LjU1MzYxNDQgMTUuNDQzODY0OCwyMCAxNiwyMCBaIE0xNiwyNCBDMTYuNTUyMjg0OCwyNCAxNywyMy41NTIyODQ4IDE3LDIzIEMxNywyMi40NDc3MTUyIDE2LjU1MjI4NDgsMjIgMTYsMjIgQzE1LjQ0NzcxNTIsMjIgMTUsMjIuNDQ3NzE1MiAxNSwyMyBDMTUsMjMuNTUyMjg0OCAxNS40NDc3MTUyLDI0IDE2LDI0IFogTTE2LDI0IiBpZD0iVHJpYW5nbGUgMjkiLz48L2c+PC9nPjwvc3ZnPg==" />
        <span>
          [{{ info }}]
        </span>
        <strong>
          {{ errorMessage }}
        </strong>
      </div>
      <p class="caption-1">
        {{ error }}
      </p>
      <br>
      <br>
      <p class="caption-2" v-html="stackTrace"></p>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import _ from '../../utils';

  export default Vue.extend({
    data: () => ({
      error: undefined as (Error | undefined),
      vm: undefined as (Vue | undefined),
      info: undefined as (string | undefined),
    }),
    computed: {
      errorMessage() {
        const error = this.error as any ?? {};
        return error.info?.message
          ?? error.data?.info?.errorInfo?.title
          ?? error.data?.Info?.ErrorInfo?.Title
          ?? error.message
          ?? error;
      },
      stackTrace() {
        try {
          const firstStackLine = this.error?.stack?.split('\n', 2).join('');
          let vueTrace = '';
          if (this.vm) {
            vueTrace = _.component.generateTrace(this.vm);
          }
          vueTrace = vueTrace
            .split('<')
            .join('&lt;')
            .split('>')
            .join('&gt;')
            .split('\n')
            .filter((line) => line !== '')
            .join('<br>');
          if (firstStackLine) {
            return `${firstStackLine}\n${vueTrace}`;
          }
          return `${vueTrace}`;
        } catch (e) {
          if (this.error) {
            if (this.error.stack) {
              return this.error.stack;
            }
            return this.error.toString();
          }
          return 'Unknown error, check the console';
        }
      },
    },
    methods: {
      onCloseClick() {
        this.$el.remove();
        // Cleanup component held in memory after it has been removed from DOM
        this.$destroy();
      },
    },
  });
</script>

<style scoped>

  .close-button {
    float: right;
  }
  .title-section {
    margin-bottom: 12px;
  }
  .title-section * {
    vertical-align: middle;
  }

  .error-container {
    align-items: center;
    background: linear-gradient(90deg,
    rgb(255, 173, 173) 0%,
    rgb(255, 199, 167) 100%);
    display: flex;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    justify-content: center;
    left: 0;
    left: 0;
    margin: 0;
    min-height: 100%;
    opacity: 0.9999;
    padding: 0;
    position: fixed;
    top: 0;
    top: 0;
    transform: scale(1);
    width: 100%;
    z-index: 9999;
  }

  .error-card {
    background: rgb(255, 255, 255);
    max-height: 90vh;
    overflow: auto;
    overflow-wrap: anywhere;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    color: black;
    margin: 0;
    min-height: 150px;
    min-height: 33%;
    padding: 16px;
    width: 66%;
  }

  @media only screen and (max-width: 600px) {
    .error-card {
      min-height: 80%;
      width: 80%;
    }
  }

</style>
